import { Paper } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { Modal, Fade, Box } from "@mui/material";
import ScenarioConsumptionChart from "./ScenarioConsumptionChart";

export default function ConsumptionRatio() {
  const state = useSelector((store) => store.dashboard);
  const { consumptionByCountryPrepared, drawerOpen } = state;
  const { categories, values } = consumptionByCountryPrepared;

  const [countryName, setCountryName] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 1,
    p: 2,
  };

  const consumptionByCountryOptions = {
    chart: {
      id: "basic-bar",
      type: "bar",
      events: {
        dataPointSelection(event, chartContext, config) {
          setCountryName(
            config.w.config.xaxis.categories[config.dataPointIndex]
          );
          handleOpen();
        },
      },
    },
    title: {
      text: "Consumption Ratio by Country",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#263238",
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        columnWidth: 1 * Math.log(values?.length + 1) * 30 + "%",
      },
    },
    xaxis: {
      categories: Array.isArray(categories)?[...categories]:[],
    },
  };

  const consumptionByCountrySeries = [
    {
      name: "Consumption Ratio",
      data: Array.isArray(values)?[...values]:[],
    },
  ];

  return (
    <div>
      <Paper elevation={2}>
        <Chart
          options={consumptionByCountryOptions}
          series={consumptionByCountrySeries}
          type="bar"
          width={drawerOpen ? "100%" : "100%"}
          height={drawerOpen ? "500" : "550"}
        />
      </Paper>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style}>
            <ScenarioConsumptionChart countryName={countryName} />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
